import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtherService from "../../services/Other";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { formatNumber } from "../../constants/commonFunction";
import { FaStar } from "react-icons/fa";
import TierCardNew from "../../component/TierCardNew";
import awardSymbol from "../../assets/images/awardSymbol.png";
import awardCup from "../../assets/images/cup.png";
import { addUserPersona } from "../../redux/slices/currentUserSlice";
import ProfileService from "../../services/Profile";
import BigBox from "../BigBox.js";
import { fetchPdf } from "../../constants/commonFunction";

const ZoneLocation = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
            const res = await OtherService.getLocation();
            if(res.success && res.response?.length > 0) {
                setData(res.response[0]);
            }
        } catch (error) {
            console.error("Zone location api error");
        }
      }
      fetchData();
    }, []);

    return (
      <div className="w-100">
      <div header={'Zone Info'}>
      <BigBox header={'Zone Info'}>
        </BigBox>
        <div style={{ width: "100%" }}>
        {Object.entries(data).map(([key, value]) => (
              <div key={key} className="row mb-3">
                <div className="col-6 fw-medium text-secondary">
                  {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                </div>
                <div className="col-6 text-dark text-end">
                  {value}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
    );
          
      
};

export default ZoneLocation;